export default __webpack_public_path__ + "static/images/wow/Failed_to_Load_Image.png";